import React from "react";
import { useTranslation } from "core/hooks/useTranslation";

import Modal from "components/common/modal";

import { POPUP_SIZE } from "constants/common.constants";

const DomainInfoComponent = ({
    record,
    onClose,
}) => {
    const { t } = useTranslation();

    const isManaged = record?.manageDNS;

    const nameServers = record?.nameservers ?? [];

    const fallbacks = record?.fallbacks ?? {};

    return (
        <Modal
            title={ isManaged ? t("backoffice.projects.nameServers") : t("backoffice.projects.fallbacks")}
            cancelText={t("backoffice.common.close")}
            onCancel={onClose}
            hideOkButton={true}
            size={isManaged ? POPUP_SIZE.SMALLEST : POPUP_SIZE.BIG}
        >
            {
                isManaged ? (
                    <div>
                        {
                            nameServers.map(server => (
                                <div className="rt--mb-8" key={server}>
                                    <span className="rt--font-normal rt--font-regular">{server}</span>
                                </div>
                            ))
                        }
                    </div>
                ) : (
                    <div>
                        {
                            Object.keys(fallbacks).map(fallback => (
                                <div className="rt--mb-8" key={fallback}>
                                    <span className="rt--font-normal rt--font-regular">
                                        <span className="rt--font-normal rt--font-regular">{fallback}</span>
                                        <strong className="rt--font-normal rt--font-regular rt--pl-8 rt--pr-8">{"-->"}</strong>
                                        <strong className="rt--font-normal rt--font-bold">{fallbacks[fallback]}</strong>
                                    </span>
                                </div>
                            ))
                        }
                    </div>
                )
            }
        </Modal>
    );
};

export default DomainInfoComponent
